import {
    UserController, StripeController
} from "controllers";


export const cancelLateBoxSubscription = async (customer, boxId) => {
    const lateBox = customer.stripe.late_box_subscriptions.find((sub) => sub.box_id === boxId);
    const subscriptionId = lateBox.subscription_id;

    await StripeController.cancelAnySubscription({ uid: customer.id, subscriptionId });
    lateBox.status = "canceled";
    lateBox.canceled_at = +new Date();
    lateBox.canceled_from = 'Tidie';

    await UserController.addStripeSubscription(customer.id, { stripe: customer.stripe });
}
